// src/pages/AuthCallback.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleAuthCallback, getReturnPathAfterLogin } from '../services/authService';
import LoadingState from '../components/common/LoadingState';
import ErrorMessage from '../components/common/ErrorMessage';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    const processCallback = async () => {
      try {
        // Get the code from the URL
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        
        if (!code) {
          // Check for error in URL
          const error = urlParams.get('error');
          if (error) {
            setError(`Authentifizierung fehlgeschlagen: ${error}`);
            return;
          }
          
          setError('Kein Authentifizierungscode von Spotify erhalten');
          return;
        }
        
        // Process the auth callback
        const success = await handleAuthCallback(code);
        
        if (success) {
          // Redirect to dashboard or the page they were trying to access
          const returnPath = getReturnPathAfterLogin();
          navigate(returnPath);
        } else {
          setError('Authentifizierung mit Spotify fehlgeschlagen');
        }
      } catch (err) {
        console.error('Error processing auth callback:', err);
        setError('Bei der Authentifizierung mit Spotify ist ein unerwarteter Fehler aufgetreten');
      }
    };
    
    processCallback();
  }, [navigate]);
  
  if (error) {
    return (
      <div className="container mx-auto mt-8 px-4">
        <ErrorMessage 
          title="Authentifizierungsfehler" 
          message={error} 
          onRetry={() => navigate('/add-metrics')}
        />
      </div>
    );
  }
  
  return (
    <div className="container mx-auto mt-8 px-4">
      <LoadingState message="Verbinde mit Spotify..." size="large" />
    </div>
  );
};

export default AuthCallback;